var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVoucherNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#1C2154",
    strokeWidth: 2.5,
    d: "M26.5 2.25c.621 0 1.184.252 1.591.659.407.407.659.97.659 1.591h0v35c0 .621-.252 1.184-.659 1.591-.407.407-.97.659-1.591.659h0-21c-.621 0-1.184-.252-1.591-.659-.407-.407-.659-.97-.659-1.591h0v-35c0-.621.252-1.184.659-1.591.407-.407.97-.659 1.591-.659h0z",
    transform: "translate(-352 -263) translate(264 234) translate(88 30) translate(13 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V44H0z",
    transform: "translate(-352 -263) translate(264 234) translate(88 30) translate(13 1)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#1C2154",
    strokeWidth: 2.5,
    d: "M26.5 2.25c.621 0 1.184.252 1.591.659.407.407.659.97.659 1.591h0v35c0 .621-.252 1.184-.659 1.591-.407.407-.97.659-1.591.659h0-21c-.621 0-1.184-.252-1.591-.659-.407-.407-.659-.97-.659-1.591h0v-35c0-.621.252-1.184.659-1.591.407-.407.97-.659 1.591-.659h0z",
    transform: "translate(-352 -263) translate(264 234) translate(88 30) translate(7 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V44H0z",
    transform: "translate(-352 -263) translate(264 234) translate(88 30) translate(7 1)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#1C2154",
    strokeWidth: 2.5,
    d: "M11.257 3.25c.584 1.898 1.204 3.08 2.169 3.927C14.357 7.996 15.614 8.5 17 8.5c1.365 0 2.605-.49 3.531-1.28.972-.828 1.6-1.984 1.704-3.27h0l5.265-.7c.621 0 1.184.252 1.591.659.407.407.659.97.659 1.591h0v35c0 .621-.252 1.184-.659 1.591-.407.407-.97.659-1.591.659h0-4.925c-.344-1.669-.932-2.904-1.868-3.796-.946-.901-2.255-1.454-3.707-1.454-1.38 0-2.632.5-3.562 1.306-.974.844-1.596 2.02-1.679 3.324h0l-5.259.62c-.621 0-1.184-.252-1.591-.659-.407-.407-.659-.97-.659-1.591h0v-35c0-.621.252-1.184.659-1.591.407-.407.97-.659 1.591-.659h0z",
    transform: "translate(-352 -263) translate(264 234) translate(88 30)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C2154",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M4.626 15L9 15M24 15L29 15M14 15L20 15",
    transform: "translate(-352 -263) translate(264 234) translate(88 30)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C2154",
    strokeWidth: 2,
    d: "M22.198 24.919l-3.377-.517-1.512-3.216c-.118-.248-.507-.248-.625 0l-1.512 3.216-3.377.517c-.132.022-.236.116-.278.247-.041.131-.007.277.09.372l2.449 2.503-.576 3.53c-.02.138.028.276.139.356.104.08.25.095.367.03l3.01-1.667 3.025 1.666c.048.03.104.044.159.044.07 0 .146-.022.201-.073.104-.08.16-.218.139-.356l-.576-3.53 2.449-2.503c.097-.095.131-.24.09-.372-.049-.13-.153-.232-.285-.247z",
    transform: "translate(-352 -263) translate(264 234) translate(88 30)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoucherNumber);
export default __webpack_public_path__ + "static/media/icon-voucher-number.dfcfe4bf.svg";
export { ForwardRef as ReactComponent };